import Cookies from "js-cookie";

/**
 * @returns The country code or undefined if the uid cookie is not set.
 * The country code reflects the user's location when they first visited the site.
 */
export function getCountryCodeFromUid() {
  const uidCountryCode = Cookies.get("uid")?.slice(0, 2)?.toUpperCase();
  // Anonymous users will have a country code of XX in the UID, we don't want to use this
  return uidCountryCode === "XX" ? undefined : uidCountryCode;
}
